import React from 'react'
import { Controller } from 'react-hook-form'

const statusOptions = ['In-process', 'Approved', 'Rejected']

const CustomCheckPortalLink = ({ row, control }: any): JSX.Element => {
    const portalField = `${row.id}.Portal`
    const linkField = `${row.id}.Link`
    const statusField = `${row.id}.Status`
    const commentField = `${row.id}.Comment`
    const disabledField = `${row.id}.IsDisabled`
    const sourceIndexField = `${row.id}.SourceIndex`

    return (
        <div className="border border-gray-300 rounded p-3 mb-3">
            <div className="fv-row mb-2">
                <label className="form-label fw-bold text-dark text-uppercase">Portal</label>
                <Controller
                    name={portalField}
                    control={control}
                    defaultValue={row.defaultPortal ?? row.content?.[0] ?? ''}
                    render={({ field }) => (
                        <input
                            className="form-control form-control-solid form-control-lg"
                            value={field.value ?? ''}
                            onChange={(event) => {
                                field.onChange(event.target.value)
                            }}
                            placeholder="Portal name"
                        />
                    )}
                />
            </div>

            <div className="fv-row mb-2">
                <label className="form-label fw-bold text-dark text-uppercase">Link</label>
                <Controller
                    name={linkField}
                    control={control}
                    defaultValue={row.defaultLink ?? row.content?.[1] ?? ''}
                    render={({ field }) => (
                        <input
                            className="form-control form-control-solid form-control-lg"
                            value={field.value ?? ''}
                            onChange={(event) => {
                                field.onChange(event.target.value)
                            }}
                            placeholder="https://..."
                        />
                    )}
                />
                <div className="mt-2">
                    <a href={row.content?.[1]} target="_blank" rel="noreferrer" className="text-primary fs-7">
                        Open current link
                    </a>
                </div>
            </div>

            <div className="fv-row mb-2">
                <label className="form-label fw-bold text-dark text-uppercase">Status</label>
                <Controller
                    name={statusField}
                    control={control}
                    defaultValue={row.defaultStatus ?? 'In-process'}
                    render={({ field }) => (
                        <select
                            className="form-select form-select-solid"
                            value={field.value}
                            onChange={(event) => {
                                field.onChange(event.target.value)
                            }}
                        >
                            {statusOptions.map((status) => (
                                <option key={status} value={status}>{status}</option>
                            ))}
                        </select>
                    )}
                />
            </div>

            <div className="fv-row mb-2">
                <label className="form-label fw-bold text-dark text-uppercase">Comment / Feedback</label>
                <Controller
                    name={commentField}
                    control={control}
                    defaultValue={row.defaultComment ?? ''}
                    render={({ field }) => (
                        <textarea
                            className="form-control form-control-solid form-control-lg"
                            rows={3}
                            value={field.value ?? ''}
                            onChange={(event) => {
                                field.onChange(event.target.value)
                            }}
                            placeholder="Add admin comment"
                        />
                    )}
                />
            </div>

            <div className="fv-row mb-2">
                <Controller
                    name={disabledField}
                    control={control}
                    defaultValue={Boolean(row.defaultDisabled)}
                    render={({ field }) => (
                        <label className="form-check form-check-custom form-check-solid">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={field.value === true}
                                onChange={(event) => {
                                    field.onChange(event.target.checked)
                                }}
                            />
                            <span className="form-check-label text-dark ms-2">Disabled / inactive</span>
                        </label>
                    )}
                />
            </div>

            <Controller
                name={sourceIndexField}
                control={control}
                defaultValue={row.sourceIndex}
                render={({ field }) => (
                    <input type="hidden" value={field.value} onChange={field.onChange} />
                )}
            />
        </div>
    )
}

export default CustomCheckPortalLink
